import { useState } from 'react';
import {
  Flex, SimpleGrid, Heading, Stack, Text, useDisclosure,
  Image, Box
} from '@chakra-ui/react';
import ModalScroll from './utils/ModalScroll/ModalScroll';

function SimpleGallery({ text, currentLang, imgList }) {
  const md = require('markdown-it')({ breaks: true });
  const subtitulo = md.render(text.sub);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalContent, setModalContent] = useState(imgList[0]);

  function enlargeProject(id) {
    setModalContent(imgList[id]);
    onOpen();
  }

  return (
    <Flex direction='column'>
      <Stack
        direction='column'
        px={['5%', '5%', '15%', '15%']}
        pt={['30%', '30%', '20%', '5%']}
        pb={['70vh', '70vh', '130vh', '15%']}
        textAlign={['center', 'center', 'center', 'left']}
      >
        <Heading>{text.tit}</Heading>
        <Text dangerouslySetInnerHTML={{ __html: subtitulo }} fontSize='md' pt={['10%', '10%', '10%', '0%']} />

        <SimpleGrid columns={[1, 2, 3, 4]} spacing={6} pt={['20%', '7%']} pb={['70%', '20%']}>
          {imgList.map((data, i) => {
            return (
              <Box
                key={i}
                cursor='pointer'
                onClick={() => enlargeProject(i)}
                textAlign='center'
                _hover={{ opacity: 0.8 }}
              >
                <Image
                  src={data.location}
                  alt={data.tit}
                  objectFit='cover'
                  w='100%'
                  h='200px'
                  borderRadius='md'
                />
                {/* <Text mt={2} fontWeight='bold'>{data.tit}</Text>
                <Text fontSize='sm'>{data.sub}</Text> */}
              </Box>
            );
          })}
        </SimpleGrid>
      </Stack>

      <ModalScroll status={isOpen} close={onClose} justifyContent='center' alignItems='center'>
        <Stack align='center' spacing={4}>
          <Image src={modalContent.location} alt={modalContent.tit} maxH='80vh' borderRadius='md' />
          <Text fontSize='2xl' fontWeight='bold'>{modalContent.tit}</Text>
          <Text fontSize='md'>{modalContent.sub}</Text>
        </Stack>
      </ModalScroll>
    </Flex>
  );
}

export default SimpleGallery;
